/**
 * 「这一单是**离线扫码**取来的」——本次会话的标记（契约 §12.2 的 `origin = 'OFFLINE_SCAN'`）。
 *
 * ## 为什么需要它（而不是「现在断网吗」）
 *
 * 收款确认的来路**不是**「此刻有没有网」，而是「这单是怎么取来的」：店员在断网时扫了顾客的
 * 订单码、把货挑好，网在这时候回来了 —— 此刻**在线**，但这笔收款仍然是离线取单的收款，
 * 契约 §12.2 要求它带 `origin = "OFFLINE_SCAN"` + `verifiedWithCustomer: true`
 * （缺了就是 422 `CUSTOMER_VERIFICATION_REQUIRED`）。
 * 只按 `navigator.onLine` 判，这一笔会被当成普通在线收款发出去 —— 服务端接受它（`origin` 缺省
 * 即 `ONLINE`），但**离线核对勾选那道理序就整条绕过去了**，而那正是 R-02 的缓解措施。
 *
 * ## 与「离线队列」的分工
 *
 * 断网期间的操作走队列（`offline/queue.ts`，`POST /orders/sync` 重放）；本文件只管
 * **取单来路**这一个布尔事实，供在线收款那一条路带字段用。两者不要合并：
 * 队列的条目会在同步成功后消失，而「这单是离线取的」在订单还开着的时候一直成立。
 *
 * 会话内有效（模块内存）：刷新页面之后，本机重新走一次取单路径就会重新标上；
 * 拿一个跨重启的持久化标记反而危险 —— 三天前离线取的单今天还在本地被标着 OFFLINE_SCAN。
 */
const offlineScanned = new Set<string>();

/** 离线解析成功的订单（扫码页的离线分支调它） */
export function markOfflineScan(orderNo: string): void {
  if (orderNo !== '') offlineScanned.add(orderNo);
}

/** 这单是不是离线扫码取来的（订单页在收款确认前读它） */
export function isOfflineScan(orderNo: string | null | undefined): boolean {
  return orderNo === null || orderNo === undefined ? false : offlineScanned.has(orderNo);
}

/** 订单走完（交付/取消）或换地点时清掉；给测试与「换地点清空会话」用 */
export function clearOfflineScans(): void {
  offlineScanned.clear();
}
